import { render, staticRenderFns } from "./ScanPopup.vue?vue&type=template&id=489fba54&scoped=true&"
import script from "./ScanPopup.vue?vue&type=script&lang=js&"
export * from "./ScanPopup.vue?vue&type=script&lang=js&"
import style0 from "./ScanPopup.vue?vue&type=style&index=0&id=489fba54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489fba54",
  null
  
)

export default component.exports